import React from 'react';
import data from '../data.json';

export default function About() {
  const { about } = data;

  return (
    <section id="about" style={{ padding: '110px 0', position: 'relative', overflow: 'hidden' }}>
      <div className="container">
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: 76, alignItems: 'center',
        }} className="about-grid">

          {/* Left — Story */}
          <div>
            <div className="section-label">About Vylinx</div>
            <h2 style={{
              fontSize: 'clamp(1.8rem, 3.5vw, 2.55rem)',
              fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', marginBottom: 20,
            }}>
              {about.headline}
            </h2>

            <p style={{ color: 'var(--gray-400)', fontSize: 14.5, lineHeight: 1.85, marginBottom: 18 }}>
              {about.story}
            </p>
            <p style={{ color: 'var(--gray-400)', fontSize: 14.5, lineHeight: 1.85, marginBottom: 34 }}>
              {about.mission}
            </p>

            {/* Why Us checklist */}
            <div style={{
              background: 'var(--bg-card)', borderRadius: 'var(--radius)',
              padding: '22px 24px', border: '1px solid var(--border)',
              marginBottom: 28,
            }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--accent2)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14 }}>
                Why choose Vylinx?
              </div>
              {about.whyUs.map((point, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '10px 0',
                  borderBottom: i < about.whyUs.length - 1 ? '1px solid var(--border)' : 'none',
                  fontSize: 14, color: 'var(--gray-300)',
                }}>
                  <span style={{
                    width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                    background: 'rgba(0,194,168,0.15)', border: '1px solid rgba(0,194,168,0.3)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, color: 'var(--accent2)', fontWeight: 900,
                  }}>✓</span>
                  {point}
                </div>
              ))}
            </div>

            {/* Values */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {about.values.map((val, i) => (
                <div key={i} style={{
                  display: 'flex', gap: 14, alignItems: 'flex-start',
                  padding: 18, borderRadius: 'var(--radius-sm)',
                  background: 'var(--bg-card)', border: '1px solid var(--border)',
                  transition: 'all var(--ease)',
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,107,43,0.3)'; e.currentTarget.style.background = 'var(--bg-card2)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-card)'; }}
                >
                  <div style={{
                    width: 42, height: 42, borderRadius: 9, flexShrink: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 19,
                    background: i === 1 ? 'rgba(0,194,168,0.14)' : i === 2 ? 'rgba(255,215,0,0.1)' : 'rgba(255,107,43,0.14)',
                    border: `1px solid ${i === 1 ? 'rgba(0,194,168,0.25)' : i === 2 ? 'rgba(255,215,0,0.2)' : 'rgba(255,107,43,0.25)'}`,
                  }}>
                    {val.icon}
                  </div>
                  <div>
                    <div style={{ fontWeight: 800, color: '#fff', fontSize: 14, marginBottom: 3 }}>{val.title}</div>
                    <div style={{ color: 'var(--gray-500)', fontSize: 13, lineHeight: 1.6 }}>{val.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Visual card */}
          <div style={{ position: 'relative' }}>
            <div style={{
              background: 'var(--bg-card2)', borderRadius: 20,
              padding: 38, border: '1px solid var(--border)',
              position: 'relative', overflow: 'hidden',
            }}>
              {/* Top accent line */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, height: 2,
                background: 'linear-gradient(90deg, var(--accent), var(--accent3), var(--accent2))',
              }} />
              {/* Watermark */}
              <div style={{
                position: 'absolute', right: -8, bottom: -8,
                fontSize: 110, opacity: 0.035, userSelect: 'none', lineHeight: 1,
              }}>🌸</div>

              <div style={{ fontSize: 44, marginBottom: 14 }}>🚀</div>
              <h3 style={{
                fontSize: '1.3rem', fontWeight: 900, color: '#fff',
                marginBottom: 9, letterSpacing: '-0.02em',
              }}>
                Kolkata's Newest Digital Challenger
              </h3>
              <p style={{ color: 'var(--gray-400)', fontSize: 13.5, lineHeight: 1.78, marginBottom: 28 }}>
                We're just getting started — and that's exactly what makes us different. Every client gets our absolute best because your success is how we build our story.
              </p>

              {/* Honest pillars */}
              {[
                { icon: '🧠', label: 'Senior Strategists', desc: 'On every account, always' },
                { icon: '📊', label: 'Transparent Reports', desc: 'No smoke and mirrors' },
                { icon: '🤖', label: 'AI-Assisted Tools', desc: 'Smarter, faster results' },
                { icon: '💰', label: 'Flat Pricing', desc: 'No hidden fees, ever' },
              ].map((p, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: 14,
                  padding: '12px 0',
                  borderBottom: i < 3 ? '1px solid var(--border)' : 'none',
                }}>
                  <div style={{
                    width: 38, height: 38, borderRadius: 8, flexShrink: 0,
                    background: i % 2 === 0 ? 'rgba(255,107,43,0.12)' : 'rgba(0,194,168,0.12)',
                    border: `1px solid ${i % 2 === 0 ? 'rgba(255,107,43,0.22)' : 'rgba(0,194,168,0.22)'}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                  }}>{p.icon}</div>
                  <div>
                    <div style={{ fontWeight: 800, color: '#fff', fontSize: 13.5 }}>{p.label}</div>
                    <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Floating badge */}
            <div style={{
              position: 'absolute', top: -16, right: -14,
              background: 'var(--accent)', color: '#fff',
              borderRadius: 11, padding: '12px 18px',
              display: 'flex', alignItems: 'center', gap: 9,
              boxShadow: '0 10px 30px rgba(255,107,43,0.42)',
              fontWeight: 800, fontSize: 13,
            }}>
              🌸 Kolkata Based
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
    </section>
  );
}
